import Swiper, { Autoplay } from 'swiper';

export default {
  init() {

    Swiper.use([Autoplay]);

    /**************************************************************
    -> Sections Swiper instances
    **************************************************************/
    function initSliders() {

        /* Shop the Post sliders */
        let sliderMain = document.querySelectorAll('.location-section .swiper-container')
        let sliderNext  = document.querySelectorAll('.location-section .swiper-next')
        let sliderPrev = document.querySelectorAll('.location-section .swiper-prev')

        let mainArray  = [];


        sliderMain.forEach(function(element, i) {
          let autoplayArgs = false;
          let loopArg = false;
          let startAt = 3;
          const slider = element.querySelectorAll('.swiper-slide');
          const slidesCount = slider.length;
          if (slider && slider.dataset && typeof slider.dataset.startsliderat !== 'undefined') {
            startAt = Number(slider.dataset.startsliderat);
          }

          if(slidesCount >= startAt) {
            autoplayArgs = {
              delay: 1,
              disableOnInteraction: false,
            }
            loopArg = true
          }

          mainArray.push(
            new Swiper(element, {
              spaceBetween: 30,
              loop: loopArg,
              slidesPerView: 'auto',
              freeMode: true,
              speed: 5000,
              watchSlidesVisibility: true,
              autoplay: autoplayArgs,
              navigation: {
                nextEl: sliderNext[i],
                prevEl: sliderPrev[i],
              },
            })
          );
        });
    }

    initSliders()

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/template-single-location.js